import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {ActionPointsService} from "../../../../service/club-gigot/action-points.service";
import {push} from "object-path";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {
    ActionPointsDTO,
    AdvanceSaleGroupProduct,
    ExtraPoints, ExtraPointsProducts
} from "../../../../model/club-gigot/action-points/action-points-configuration.model";
import {forEach} from "lodash";
import {
    ActionPointsAdvanceSaleResult
} from "../../../../model/club-gigot/action-points/action-points-advance-sale-result.model";
import {ActionPointType} from "../../../../model/club-gigot/action-points/_enum/action-point.enum";
import {SaveActionPointsDTO} from "../../../../model/club-gigot/action-points/save-action-point.model";
import {finalize} from "rxjs/operators";
import {AdvanceSaleService} from "../../../../service/club-gigot/advance-sale.service";
import {$e} from "codelyzer/angular/styles/chars";

@Component({
  selector: 'kt-dialog-extra-points',
  templateUrl: './dialog-extra-points.component.html',
  styleUrls: ['./dialog-extra-points.component.scss']
})
export class DialogExtraPointsComponent implements OnInit {

    public loadingData$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public advancedSaleProductForm : FormGroup;
    public extraPointsForm : FormGroup;

    public displayedColumnsProduct = ['product', 'requiredQuantity', 'group'];
    public tableDataSource: MatTableDataSource<any>;
    public _isEditMode: boolean = false;
    public continue$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public filteredProducts;
    public groupNumbers = [1,2,3,4,5,6,7,8,9];

    constructor(private dialogRef: MatDialogRef<DialogExtraPointsComponent>,
                private actionPointsService: ActionPointsService,
                private cdr: ChangeDetectorRef,
                @Inject (MAT_DIALOG_DATA)
                public data: DialogData,
                public advanceSaleService: AdvanceSaleService){ }
  ngOnInit() {
        this._isEditMode = this.data.extraPoints != null;
        this.filteredProducts = this.data.products.filter((product, index, self) =>
             index === self.findIndex((t) => (
                t.product.code === product.product.code
                ))
        );
        this.buildForms();
    }

  public buildForms() {
        if (this._isEditMode) {
            this.extraPointsForm = new FormGroup({
                points: new FormControl(this.data.extraPoints.points),
                name: new FormControl(this.data.extraPoints.name),
                products: new FormArray(this.setProductForm())
            });
        } else {
            this.extraPointsForm = new FormGroup({
                points: new FormControl(),
                name: new FormControl(),
                products: new FormArray(this.setProductForm())
            });
        }
      this.tableDataSource = new MatTableDataSource(this.getFormArray().controls);
  }

  public setProductForm(): FormGroup[] {
      let form: FormGroup[] = [];
      if (this._isEditMode) {
          let groupNumberCount = 1;
         for (let product of this.data.extraPoints.extraPointsProducts) {
             let codes = product.productCode.split(",");
             for (let code of codes) {
                 let formGroup = new FormGroup({
                     quantityRequired: new FormControl(product.requiredQuantity),
                     product: new FormControl(code),
                     groupNumber: new FormControl(groupNumberCount)
                 });
                 formGroup.get("groupNumber").setValue(groupNumberCount);
                 form.push(formGroup);
             }
             groupNumberCount++;
         }

         for (let product of this.filteredProducts) {
             let productAdded = this.data.extraPoints.extraPointsProducts.find(x => x.productCode.includes(product.product.code));
             if (productAdded != null) {

             } else {
                 let formGroup = new FormGroup({
                     quantityRequired: new FormControl(0),
                     product: new FormControl(product.product),
                     groupNumber: new FormControl(null)
                 });
                 form.push(formGroup);
             }
         }
      }
      else {
          for (let product of this.filteredProducts) {
              let formGroup = new FormGroup({
                  quantityRequired: new FormControl(0),
                  product: new FormControl(product.product),
                  groupNumber: new FormControl(null)
              });
              form.push(formGroup);
          }
      }

      return form;
  }

    public getFormArray(): FormArray{
        return this.extraPointsForm.controls['products'] as FormArray;
    }

    public onNoClick(): void {
        this.dialogRef.close(new ActionPointsAdvanceSaleResult(true));
    }

    public onContinue(): void{
        this.continue$.next(true)
    }

    public onReturn(): void{
        this.continue$.next(false)
    }

    public onCreate():void{
        //this.loading$.next(true);
        let extraPoints: ExtraPoints = new ExtraPoints();
        extraPoints.extraPointsProducts = [];
        for(let dat of this.getFormArray().controls){
            if (dat.value.quantityRequired > 0 || dat.value.groupNumber != null) {
                let product = new ExtraPointsProducts();

                let addedProd = extraPoints.extraPointsProducts.find(x => x.groupNumber != null && x.groupNumber == dat.value.groupNumber);

                if (addedProd != null && addedProd != undefined) {
                    addedProd.productCode = addedProd.productCode.concat(",");
                    addedProd.productCode = addedProd.productCode.concat(dat.value.product.code);
                } else {
                    product.requiredQuantity = dat.value.quantityRequired;
                    product.productCode = dat.value.product.code;
                    product.groupNumber = dat.value.groupNumber;
                    extraPoints.extraPointsProducts.push(product);
                }
            }


        }

        extraPoints.name = this.extraPointsForm.controls['name'].value;
        extraPoints.points = this.extraPointsForm.controls['points'].value;
        extraPoints.advanceSaleConfiguration = this.advanceSaleService.getSelectedAdvanceSale().id;

        this.actionPointsService
            .createExtraPoints(extraPoints, extraPoints.advanceSaleConfiguration)
            .pipe(
                finalize(() => {
                })
            )
            .subscribe();
        this.dialogRef.close(new ActionPointsAdvanceSaleResult(false, true));

    }

    public groupChanged($event, productForm) {
        productForm.controls.groupNumber.setValue($event.value);
    }

}

export interface DialogData {
    extraPoints: ExtraPoints | null;
    products;
}
